import { backendFetch } from './apiUtils';

export const submitIEImport = async (loadId, currencyCode = '') => {
  return await backendFetch({
    url: 'thymeit/import',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: loadId, resubmission: 1, currencyCode }),
    },
    method: 'POST',
  });
};

export const submitIEExport = async (loadId) => {
  return await backendFetch({
    url: 'thymeit/export',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: loadId, resubmission: 1 }),
    },
    method: 'POST',
  });
};
